import { CommonModule, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepicker, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-efsrfile-download',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgbDatepickerModule, JsonPipe,NgbDatepicker],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './efsrfile-download.component.html',
  styleUrl: './efsrfile-download.component.scss'
})
export class EFSRFileDownloadComponent {
  isDisabled : boolean = false;
  DateSelect : any = null;
  DateSelectObj : any = null;
  
  CheckIn : any = null;
  CheckOut : any = null;
 
  LinkToClick = '';
  constructor(
    private dateFormate: CustomDateParserFormatter,
    private toast: ToastService,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
  }

  Search(){
    if(this.DateSelect === '' || this.DateSelect === null){
      this.toast.show({ message: 'Please Select Date!', type: toastTypeEnum.warning });
      return
    }
    this.DateSelectObj = this.dateFormate.Newformat1(this.DateSelect);
    this.CheckIn = 'checkinout_'+ this.DateSelectObj +'0010.xlsx'
    this.CheckOut = 'checkinout_'+ this.DateSelectObj +'0945_1.xlsx'
    this.LinkToClick =  '';
  }

  Load(type: string) {
    let fileUrl: string = '';
    if (type === 'In') {
      this.LinkToClick = 'https://webftp.maxus.co.in/TransovativeExcelFileBkp/' + this.CheckIn;
      fileUrl = this.LinkToClick;
    } else if (type === 'Out') {
      this.LinkToClick = 'https://webftp.maxus.co.in/TransovativeExcelFileBkp/' + this.CheckOut;
      fileUrl = this.LinkToClick;
    }
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.download = fileUrl;  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } 
  blank(){
    this.CheckIn = ''
    this.CheckOut = ''
  }
}
